/**
 * Main entry point for the HumanBehavior SDK
 */

// Import the main tracker first
import { HumanBehaviorTracker, identifyUserGlobally, sendEventGlobally, isGlobalTrackerAvailable } from '@humanbehavior/core';

// Re-export everything from core
export * from '@humanbehavior/core';

// Explicitly re-export HumanBehaviorTracker to ensure it's available
export { HumanBehaviorTracker, identifyUserGlobally, sendEventGlobally, isGlobalTrackerAvailable };

// Create an initialization function
export const init = (apiKey: string, ingestionUrl?: string, options?: any) => {
  return new HumanBehaviorTracker(apiKey, ingestionUrl, options);
};

// For UMD builds, expose the class and init function globally
if (typeof window !== 'undefined') {
  (window as any).HumanBehaviorTracker = HumanBehaviorTracker;
  (window as any).humanbehavior = { init };
}